export class VideoCalendarFormModel {
  agreement: boolean;
  firstName: string;
  lastName: string;
  email: string;
  subject: string;
  campaignId: number;
  date: Date;
}
